import React from "react";
import { Link } from "react-router-dom";
import {
  Home,
  CloudLightning,
  LayoutPanelLeft,
  AppWindow,
  DoorOpen,
  Waves,
  Hammer,
  ArrowRight,
} from "lucide-react";
import { services } from "../mock";

const iconMap = {
  Home,
  CloudLightning,
  LayoutPanelLeft,
  AppWindow,
  DoorOpen,
  Waves,
  Hammer,
};

const Services = ({ withImages = false }) => {
  return (
    <section className="bg-brand-cream py-20" id="services">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12 max-w-2xl mx-auto">
          <p className="text-brand-orange font-semibold tracking-[0.18em] text-sm uppercase mb-3">
            Our Home Services
          </p>
          <h2 className="font-display font-extrabold text-brand-navy text-3xl md:text-4xl">
            A Full-Service Construction & Roofing Company
          </h2>
          <div className="w-20 h-1 bg-brand-orange rounded-full mx-auto mt-4 mb-5" />
          <p className="text-slate-600 leading-relaxed">
            From roofing and general contracting to home remodels, we offer
            comprehensive home improvement services. With four decades of proven
            success, our track record speaks for itself.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => {
            const Icon = iconMap[s.icon] || Home;
            return (
              <div
                key={s.slug}
                className="group bg-white rounded-2xl overflow-hidden border border-black/5 shadow-sm hover:shadow-xl hover:-translate-y-1.5 transition-all"
              >
                {withImages && (
                  <div className="h-44 overflow-hidden">
                    <img
                      src={s.image}
                      alt={s.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                )}
                <div className="p-6">
                  <div className="w-13 h-13 w-14 h-14 rounded-xl bg-brand-navy group-hover:bg-brand-orange flex items-center justify-center mb-4 transition-colors">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="font-display font-bold text-brand-navy text-xl mb-2">
                    {s.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed mb-4">
                    {s.short}
                  </p>
                  <Link
                    to={`/services/${s.slug}`}
                    className="inline-flex items-center gap-1.5 text-brand-orange font-semibold text-sm group-hover:gap-2.5 transition-all"
                  >
                    Learn More
                    <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
